import {User} from "../users/User";

export type Authentication = {
    user: User;
    isOrganizer: boolean;
};

export const validEmailRegex = /^.*@publicissapient.(fr|com)$/;
